import { render, staticRenderFns } from "./DeepLinkReceipt.vue?vue&type=template&id=dbdbb55c&scoped=true&"
import script from "./DeepLinkReceipt.vue?vue&type=script&lang=js&"
export * from "./DeepLinkReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdbb55c",
  null
  
)

export default component.exports